/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const RewardSelection = {
    RAFFLE_QUEST_COMPLETE: 'RAFFLE_QUEST_COMPLETE',
    RAFFLE_POINT_ENTRIES: 'RAFFLE_POINT_ENTRIES',
    HIGHEST_POINTS: 'HIGHEST_POINTS',
    MANUAL: 'MANUAL',
    ACTIVE_CHALLENGE_MEMBER: 'ACTIVE_CHALLENGE_MEMBER',
    GRAND_PRIZE_RAFFLE: 'GRAND_PRIZE_RAFFLE'
} as const;
export type RewardSelection = typeof RewardSelection[keyof typeof RewardSelection];


export function instanceOfRewardSelection(value: any): boolean {
    for (const key in RewardSelection) {
        if (Object.prototype.hasOwnProperty.call(RewardSelection, key)) {
            if (RewardSelection[key as keyof typeof RewardSelection] === value) {
                return true;
            }
        }
    }
    return false;
}

export function RewardSelectionFromJSON(json: any): RewardSelection {
    return RewardSelectionFromJSONTyped(json, false);
}

export function RewardSelectionFromJSONTyped(json: any, ignoreDiscriminator: boolean): RewardSelection {
    return json as RewardSelection;
}

export function RewardSelectionToJSON(value?: RewardSelection | null): any {
    return value as any;
}

export function RewardSelectionToJSONTyped(value: any, ignoreDiscriminator: boolean): RewardSelection {
    return value as RewardSelection;
}

